/* Think Crucial Phase 1 product page (snippets/tc-buybox-*.liquid, tc-bb-form.liquid, tc-sticky-atc.liquid).
   Keeps the price, cost per use, button labels and variant ids in step with the selected variant and quantity,
   runs the quantity stepper and the "+N more" fits chips, and shows the mobile sticky bar while the main button
   is off-screen. It never adds to the cart: think-crucial.js InlineCart owns the add for both buttons. */
(function () {
  var form = document.querySelector('form[data-tc-bb-form]');
  if (!form) { return; }
  var doc = document.documentElement;
  if (doc.className.indexOf('tc-pdp') === -1) { doc.className += ' tc-js tc-pdp'; }

  var variants = [];
  try { variants = JSON.parse(form.querySelector('[data-tc-variants]').textContent) || []; } catch (e) {}
  var byId = {};
  for (var i = 0; i < variants.length; i++) { byId[variants[i].id] = variants[i]; }

  var mode = form.getAttribute('data-tc-mode');
  var scope = document.querySelector('.tc-pdp') || document;
  var mainBtn = form.querySelector('[data-tc-atc-main]');
  var mainLabel = form.querySelector('[data-tc-atc-label]');
  var stickyBtn = form.querySelector('[data-tc-atc-sticky]');
  var sticky = form.querySelector('[data-tc-sticky]');
  var qtyInput = form.querySelector('input[name="quantity"]');

  function each(sel, fn) { var l = scope.querySelectorAll(sel); for (var j = 0; j < l.length; j++) { fn(l[j]); } }
  function money(cents) {
    var p = (Math.round(cents) / 100).toFixed(2).split('.');
    return '$' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1];
  }
  function selected() {
    var r = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"][type="hidden"]');
    return (r && byId[r.value]) || variants[0];
  }
  function qty() {
    var n = parseInt(qtyInput && qtyInput.value, 10);
    return n > 0 ? Math.min(n, 99) : 1;
  }

  function render() {
    var v = selected();
    if (!v) { return; }
    var q = qty();
    each('[data-tc-price]', function (el) { el.textContent = money(v.price); });
    each('[data-tc-compare]', function (el) {
      var show = v.compare > v.price;
      el.hidden = !show;
      var amt = el.querySelector('[data-tc-compare-amt]');
      if (show && amt) { amt.textContent = money(v.compare); }
    });
    each('[data-tc-per]', function (el) {
      var txt = '';
      if (mode === 'cleaner' && v.uses > 0) { txt = 'About ' + money(v.price / v.uses) + ' per use (' + v.uses + ' uses)'; }
      else if (mode !== 'cleaner' && v.units > 1) { txt = money(v.price / v.units) + ' each'; }
      el.textContent = txt;
      el.hidden = !txt;
    });
    var btns = [mainBtn, stickyBtn];
    for (var b = 0; b < btns.length; b++) {
      if (!btns[b]) { continue; }
      btns[b].setAttribute('data-variant-id', v.id);
      btns[b].setAttribute('data-variant-qty', q);
      btns[b].disabled = !v.available;
    }
    if (mainLabel) {
      mainLabel.textContent = v.available ? 'Add ' + (q > 1 ? q + ' ' : '') + 'to cart — ' + money(v.price * q) : 'Sold out';
    }
    if (stickyBtn) { stickyBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
  }

  function showVariantImage(v) {
    if (!v || !v.image || !window.jQuery || !jQuery.fn || !jQuery.fn.slick) { return; }
    var slide = document.querySelector('.product-thumbnails .product-slider-slide[data-image="' + v.image + '"]');
    if (slide) { jQuery('.slick-slider').slick('slickGoTo', slide.getAttribute('data-index')); }
  }

  function syncUrl(v) {
    if (!v || variants.length < 2 || !window.history || !history.replaceState) { return; }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState(history.state, '', url.toString());
  }

  form.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'id') { render(); var v = selected(); syncUrl(v); showVariantImage(v); }
    else if (t.name === 'quantity') { if (qtyInput) { qtyInput.value = qty(); } render(); }
  });
  if (qtyInput) { qtyInput.addEventListener('input', render); }

  form.addEventListener('click', function (e) {
    var step = e.target.closest ? e.target.closest('[data-tc-step]') : null;
    if (!step || !qtyInput) { return; }
    qtyInput.value = Math.max(1, Math.min(99, qty() + parseInt(step.getAttribute('data-tc-step'), 10)));
    render();
  });

  /* ajaxify-shop.js binds a submit handler to every form[action*="/cart/add"] that runs its own add
     (Shopify.addItemFromForm plus a modal). Normally no submit fires here, because InlineCart's click
     handler calls preventDefault. If one does (Enter before think-crucial.js has bound), keep ajaxify out:
     hand it to the same InlineCart handler when that is bound, else let the browser post to /cart/add. */
  document.addEventListener('submit', function (e) {
    if (e.target !== form) { return; }
    e.stopPropagation();
    var bound = window.jQuery && jQuery._data && mainBtn && (jQuery._data(mainBtn, 'events') || {}).click;
    if (bound && mainBtn && !mainBtn.disabled) { e.preventDefault(); jQuery(mainBtn).triggerHandler('click'); }
  }, true);

  scope.addEventListener('click', function (e) {
    var more = e.target.closest ? e.target.closest('[data-tc-more]') : null;
    if (!more) { return; }
    var list = document.getElementById(more.getAttribute('aria-controls'));
    if (!list) { return; }
    var open = list.classList.toggle('is-open');
    more.setAttribute('aria-expanded', open ? 'true' : 'false');
    more.textContent = more.getAttribute(open ? 'data-tc-less-label' : 'data-tc-more-label');
  });

  /* Sticky bar: shown on screens up to 768px wide whenever the main button is off-screen (below the fold on first load,
     scrolled past, or under the header). The header (header C, .tcs-hdr) is sticky and hides on scroll down / returns on
     scroll up, so its bottom edge is re-read on every check rather than fixed into an IntersectionObserver rootMargin. */
  if (sticky && mainBtn && window.matchMedia) {
    var mq = window.matchMedia('(max-width: 768px)');
    var headerBottom = function () {
      var h = document.querySelector('.tcs-hdr') || document.querySelector('header.banner');
      if (!h) { return 0; }
      var pos = window.getComputedStyle(h).position;
      if (pos !== 'fixed' && pos !== 'sticky') { return 0; }
      return Math.max(0, Math.round(h.getBoundingClientRect().bottom));
    };
    var raf = 0;
    var update = function () {
      raf = 0;
      var r = mainBtn.getBoundingClientRect();
      var mainOnScreen = r.bottom > headerBottom() + 4 && r.top < window.innerHeight - 76;
      var show = mq.matches && !mainOnScreen;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyBtn) { stickyBtn.tabIndex = show ? 0 : -1; }
    };
    var queue = function () { if (!raf) { raf = requestAnimationFrame(update); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    if (mq.addEventListener) { mq.addEventListener('change', queue); } else if (mq.addListener) { mq.addListener(queue); }
    update();
  }

  /* Dispatch line: assets/tc-dispatch.js (shared with the cart drawer; business days, USPS holidays 2026-2027).
     Until it has loaded, the server-rendered "Ships in 1–3 business days" stays. */
  var dispatchEl = form.querySelector('[data-tc-dispatch]');
  function dispatchText(now) { return window.tcDispatch ? window.tcDispatch.text(now) : null; }
  function updateDispatch() {
    var t = dispatchText(new Date());
    if (t && dispatchEl.textContent !== t) { dispatchEl.textContent = t; }
  }
  if (dispatchEl) {
    updateDispatch();
    setInterval(updateDispatch, 30000);
    document.addEventListener('visibilitychange', updateDispatch);
    window.addEventListener('pageshow', updateDispatch);
  }

  render();
})();
